// Horizontal numbered stepper — same pattern as inventory Stock Workflow.
import React from "react";
import { C } from "../constants";
import SvgIcon from "../SvgIcon";

export const AUTO_STEPS = [
  { id: "insurance-plan", label: "Insurance Plan" },
  { id: "eligibility", label: "Eligibility" },
  { id: "preauth", label: "Pre-Auth" },
  { id: "claim", label: "Claim" },
  { id: "communication", label: "Communication" },
  { id: "payment-notice", label: "Payment Notice" },
];

export default function InsuranceWorkflowStepper({ steps = AUTO_STEPS, activeId, onSelect }) {
  const activeIndex = Math.max(0, steps.findIndex((s) => s.id === activeId));

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <h3 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: C.text }}>Cashless Workflow</h3>
      </div>
      <div style={{ position: "relative", padding: "16px 12px 8px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            overflowX: "auto",
            paddingBottom: "8px",
          }}
        >
          {steps.map((step, i) => {
            const isActive = i === activeIndex;
            const isCompleted = i < activeIndex;
            const isLast = i === steps.length - 1;
            return (
              <div key={step.id} style={{ display: "flex", alignItems: "flex-start", flexShrink: 0 }}>
                <button
                  type="button"
                  onClick={() => onSelect(step.id)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "96px",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  <span
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: `2px solid ${isActive || isCompleted ? C.primary : C.border}`,
                      background: isActive || isCompleted ? C.primary : "#fff",
                      color: isActive || isCompleted ? "#fff" : C.primary,
                      fontWeight: 700,
                      fontSize: "13px",
                      boxShadow: isActive ? "0 4px 12px rgba(13,35,63,0.18)" : "none",
                      boxSizing: "border-box",
                    }}
                  >
                    {isCompleted ? <SvgIcon name="check" size={16} color="#fff" /> : i + 1}
                  </span>
                  <span
                    style={{
                      marginTop: "8px",
                      fontSize: "11px",
                      fontWeight: isActive ? 700 : 600,
                      color: isActive ? C.primaryHover : C.textSub,
                      textAlign: "center",
                      lineHeight: 1.25,
                      padding: "0 4px",
                    }}
                  >
                    {step.label}
                  </span>
                </button>
                {!isLast && (
                  <span
                    style={{
                      width: "32px",
                      height: "2px",
                      marginTop: "17px",
                      flexShrink: 0,
                      background: isCompleted ? C.primary : C.border,
                      borderRadius: "1px",
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const cardStyle = {
  background: C.card,
  borderRadius: "12px",
  border: `1px solid ${C.border}`,
  boxShadow: "0 2px 8px rgba(13,35,63,0.07)",
};

const headerStyle = {
  padding: "14px 20px",
  borderBottom: `1px solid ${C.border}`,
};
